import { render, staticRenderFns } from "./AdminExamSettingsCriteriaIndex.vue?vue&type=template&id=5e52b522"
import script from "./AdminExamSettingsCriteriaIndex.vue?vue&type=script&lang=js"
export * from "./AdminExamSettingsCriteriaIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports